<template>
  <div class="range-control">
    <div class="ocx-box">
      <playerBox ref="player" playBoxClass="range"></playerBox>
    </div>
    <div class="list-content">
      <div style="padding: 3px 16px">出入口设备</div>
      <el-scrollbar style="height: calc(100% - 24px)">
        <div
          class="list-item"
          style="padding: 10px"
          v-for="(items, index) in deviceList"
          :key="index"
        >
          <div class="item-title" @click="items.show = !items.show">
            <span>
              {{ items.name }}
            </span>
            <el-button
              v-if="items.children && items.children.length"
              type="text"
              :class="items.show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></el-button>
            <span v-else style="color: gray">无设备信息</span>
          </div>
          <el-collapse-transition>
            <ul class="itemChildren" v-show="items.show">
              <li
                v-for="(item, childrenIndex) in items.children"
                :key="childrenIndex"
                :class="[
                  'list-text',
                  item.deviceMark == 26 ? 'list-text__other' : '',
                ]"
              >
                <span class="list-name"
                  >{{ item.deviceName }}
                  <span v-if="item.deviceMark == 26">( 语音立柱 )</span>
                </span>

                <div v-if="item.deviceMark == 26" class="list-other">
                  <span class="list-name">
                    {{ item.targetDeviceName }}
                    <span>( 监听主机 )</span>
                  </span>

                  <span style="display: flex">
                    <el-button
                      type="text"
                      v-if="item.deviceMark == 26"
                      @click="handleActionC(item, 0)"
                      size="mini"
                    >
                      <img
                        title="开启对讲"
                        class="icon"
                        src="@src/common/assets/images/语音.png"
                        alt=""
                      />
                    </el-button>
                    <el-button
                      type="text"
                      title="关闭对讲"
                      v-if="item.deviceMark == 26"
                      @click="handleActionC(item, 1)"
                      icon="el-icon-switch-button"
                    >
                    </el-button>
                  </span>
                </div>
                <span style="display: flex" v-if="item.deviceMark != 26">
                  <el-button
                    type="text"
                    v-if="item.deviceMark == 22"
                    @click="handleActionA(item)"
                    size="mini"
                  >
                    <img
                      title="操作闸机"
                      class="icon"
                      src="@src/common/assets/images/人道闸.png"
                      alt=""
                  /></el-button>
                  <el-button
                    type="text"
                    v-if="item.deviceMark == 25"
                    @click="handleActionB(item)"
                    size="mini"
                  >
                    <img
                      class="icon"
                      title="操作道闸"
                      src="@src/common/assets/images/车道闸.png"
                      alt=""
                    />
                  </el-button>
                  <!-- <el-button
                    type="text"
                    v-if="item.deviceMark == 26"
                    @click="handleActionC(item, 0)"
                    size="mini"
                  >
                    <img
                      title="开启对讲"
                      class="icon"
                      src="@src/common/assets/images/语音.png"
                      alt=""
                    />
                  </el-button>
                  <el-button
                    type="text"
                    title="关闭对讲"
                    v-if="item.deviceMark == 26"
                    @click="handleActionC(item, 1)"
                    icon="el-icon-switch-button"
                  >
                  </el-button> -->
                </span>
              </li>
            </ul>
          </el-collapse-transition>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { getwayControl } from "../api";
import playerBox from "@src/modules/gatewayManager/components/player-box.vue";
export default {
  data() {
    return {
      deviceList: [
        {
          name: "出入口车辆道闸设备",
          show: false,
          children: [],
        },
        { name: "出入口人行闸机设备", show: false, children: [] },
        { name: "出入口语音对讲设备", show: false, children: [] }, //广播
      ],
      detailInfo: {},
    };
  },
  components: { playerBox },
  methods: {
    handleClose() {
      this.$refs.player.handleStopAllVideo();
      this.deviceList.forEach((el) => {
        el.show = false;
      });
    },
    // 操作闸机
    handleActionA(item) {
      let params = {
        openType: "1",
        deviceIdList: [item.deviceId],
      };
      this.$fetch(getwayControl.controlTurnstilegate, params).then((res) => {
        if (res.success) {
          this.$message.success(item.deviceName + "[开闸成功]");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 操作道闸
    handleActionB(item) {
      this.$fetch(getwayControl.controlVehicleBarrier, {
        thirdDeviceId: item.thirdDeviceId,
        cmdType: 1,
      }).then((res) => {
        if (res.success) {
          this.$message.success(item.deviceName + "[道闸操作成功]");
        } else {
          this.$message.error(res.msgContent || "道闸操作失败");
        }
      });
    },
    // 操作语音设备
    handleActionC(item, type) {
      console.log(item);
      // thirdDeviceId 立柱
      // targetThirdDeviceId:主机
      let params = {
        // 源终端ID，话筒
        sourceTerminalId: item.targetThirdDeviceId,
        // 0 开始 1 停止
        stop: type,
        commnandType: 1,

        //目标终端ID列表，广播设备
        targetTerminalIdList: [item.thirdDeviceId],
      };
      this.$fetch(getwayControl.manualRemoteCall, params).then((res) => {
        if (res.success) {
          this.$message.success(item.deviceName + "[语音设备操作成功]");
        } else {
          this.$message.error(res.msgContent || "语音设备操作失败");
        }
      });
    },
    handleOpen(data, type) {
      this.detailInfo = data;
      this.type = type;
      this.deviceList[1].children = data.deviceSceneDetailMap?.["22"];
      this.deviceList[0].children = data.deviceSceneDetailMap?.["25"];
      this.deviceList[2].children = data.deviceSceneDetailMap?.["26"];
      this.detailInfo.cameraList = data.deviceSceneDetailMap?.["18"];
      this.$nextTick(() => {
        let deviceNum = this.detailInfo.cameraList.length;
        if (deviceNum > 0) {
          let windowNumber = deviceNum == 1 ? 1 : deviceNum < 9 ? 4 : 9;
          this.$refs.player.windowNumber = windowNumber;
          this.detailInfo.cameraList.forEach((item, index) => {
            this.$refs.player.handlePlayLive(
              {
                thirdCameraId: item.thirdDeviceId,
                name: item.deviceName,
              },
              index + 1
            );
          });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
:deep .el-icon-switch-button {
  font-size: 20px;
}
.range-control {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
}
.list-content {
  height: 100%;
  width: 35%;
  max-width: 400px;
  // position: absolute;
  // right: -300px;
  background: #181f2e;
  transition: right 0.3s;
  padding: 12px 1px;
  &.show {
    // right: 0px;
  }
  .el-button {
    font-size: 15px;
    color: #fff !important;
  }
  .itemChildren {
    background: #1e2534;
    .icon {
      width: 22px;
    }
  }
  .item-title {
    color: #fff;
    background: #0d121c;
    padding: 8px 9px;
  }
  .list-text {
    padding: 8px 9px;
    color: #9aa6c1;
    background: #1e2534;
    border-bottom: 1px solid #3b4253;
    &:hover {
      background: rgba(13, 18, 28, 1);
    }
    // &.check {
    //   background: #0d121c;
    // }
  }
  .list-other {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #3b4253;
  }
  .list-text:last-child {
    border-bottom: none;
  }
  .item-title,
  .list-text {
    font-size: 14px;
    height: 40px;
    font-weight: 400;
    // line-height: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // flex-wrap: wrap;
    &__other {
      height: auto !important;
      min-height: 40px !important;
      flex-wrap: wrap !important;
      .list-name {
        height: 40px;
        line-height: 40px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
}
.ocx-box {
  height: 100%;
  flex: 1;
}
.device-btn {
  background: rgba(22, 29, 49, 1);
  border: 1px solid rgba(59, 66, 83, 1);
  border-radius: 5px;
  width: 175px;
  height: 35px;
  //   height: 29px;
  text-align: center;
  //   line-height: 29px;
  pointer-events: auto;
  //   padding: 0 8px;
  //   padding: 8px;
  padding: 0 4px;
  margin-right: 10px;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  i {
    line-height: 28px;
  }
}
.m-5 {
  margin-top: 5px;
}
.left {
  @extend .m-5;
  //   width: 200px;
  //   padding-right: 22px;
  //   border-right: 2px solid #807a7a;;
}
.middle {
  @extend .m-5;
  //   width: 300px;
  //   padding: 0 22px;
  //   border-right: 2px solid #807a7a;
}
.right {
  @extend .m-5;
  //   width: 300px;
  //   padding: 0 22px;
}
.full {
  position: absolute;
  right: 10px;
  bottom: 10px;
  cursor: pointer;

  i {
    font-size: 30px;
    font-size: 28px;
    line-height: 40px;
  }
}
.border-2 {
  border-right: 2px solid #807a7a;
}
.control-wrap {
  margin-top: 20px;
  display: flex;

  //   :nth-child(1),
  //   :nth-child(2) {
  //     border-right: 2px solid #807a7a;
  //   }
  .device-list {
    width: 32%;
    margin-right: 5px;
    flex-wrap: wrap;
  }
}
</style>